import type { TAuditLogRes } from 'api/swagger';
import type { ICorrelationGroupPosition } from './types.ts';

export const getCorrelationGroupPosition = (auditLogs: TAuditLogRes[], index: number): ICorrelationGroupPosition => {
  const correlationId = auditLogs[index]?.correlationId;

  const hasSamePreviousCorrelation = Boolean(correlationId && correlationId === auditLogs[index - 1]?.correlationId);
  const hasSameNextCorrelation = Boolean(correlationId && correlationId === auditLogs[index + 1]?.correlationId);

  return {
    hasSameNextCorrelation,
    isGrouped: hasSamePreviousCorrelation || hasSameNextCorrelation,
  };
};
